import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UserNotificationAction } from '@arc/arc-shared-frontend';
import { exhaustMap, of } from 'rxjs';
import {
  HostedPaymentsPadResultComponentPaymentRulesActions,
  HostedPaymentsSelectPaymentMethodPaymentRulesActions,
  PoaPadResultComponentPaymentRulesActions,
  PoaSelectPaymentMethodPaymentRulesActions,
  PoiPadResultComponentPaymentRulesActions,
  PoiSelectPaymentMethodPaymentRulesActions,
  PoiStripeResultIntlPaymentRulesActions,
} from '../component-actions';
import { TranslateService } from '@ngx-translate/core';
import { PaymentRulesActions } from '../payment-rules';

@Injectable()
export class SharedPaymentRulesEffects {
  constructor(
    private actions$: Actions,
    private translate: TranslateService,
  ) {}

  displayGetPaymentRuleError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        PaymentRulesActions.GetPaymentRuleErrorAction,
        PoiPadResultComponentPaymentRulesActions.loadPaymentRulesError,
        PoiStripeResultIntlPaymentRulesActions.loadPaymentRulesError,
        PoaPadResultComponentPaymentRulesActions.loadPaymentRulesError,
        HostedPaymentsPadResultComponentPaymentRulesActions.loadPaymentRulesError,
      ),
      exhaustMap(() =>
        of(
          new UserNotificationAction({
            type: 'error',
            message: this.translate.instant(
              'ARC_PAYMENT_FAILED_TO_LOAD_PAYMENT_RULES',
            ) as string,
          }),
        ),
      ),
    ),
  );

  displayPaymentInclusionExclusionRuleError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        PoiPadResultComponentPaymentRulesActions.loadInclusionExclusionRulesError,
        PoiSelectPaymentMethodPaymentRulesActions.inclusionExclusionListError,
        PoaPadResultComponentPaymentRulesActions.loadInclusionExclusionRulesError,
        PoaSelectPaymentMethodPaymentRulesActions.inclusionExclusionListError,
        HostedPaymentsPadResultComponentPaymentRulesActions.loadInclusionExclusionRulesError,
        HostedPaymentsSelectPaymentMethodPaymentRulesActions.cardInclusionExclusionListError,
      ),
      exhaustMap(() =>
        of(
          new UserNotificationAction({
            type: 'error',
            message: this.translate.instant(
              'ARC_PAYMENT_FAILED_TO_LOAD_BUYER_ACCOUNT_CARD_RULES',
            ) as string,
          }),
        ),
      ),
    ),
  );

  displayPaymentRemittanceRulesError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        PaymentRulesActions.GetPaymentRemittanceRuleErrorAction,
        PoaPadResultComponentPaymentRulesActions.getPaymentRemittanceRulesError,
      ),
      exhaustMap(() =>
        of(
          new UserNotificationAction({
            type: 'error',
            message: this.translate.instant(
              'ARC_PAYMENT_FAILED_TO_LOAD_REMITTANCE_RULES',
            ) as string,
          }),
        ),
      ),
    ),
  );
}
